<template>
  <div class = "img-preview-wrap">
    <img :src = "src" />
    <div class="demo-upload-list-cover">
        <Icon type="ios-eye-outline" @click.native="handleView()"></Icon>
        <Icon type="ios-download-outline" @click.native="handleDownload()"></Icon>
    </div>
  </div>
</template>

<script>
import { setTimeout } from 'timers';
export default {
  props:{
    src: String
  },
  data(){
    return {

      kstyles: {
        previewImg_heigth:{
          height:'100%',
        },
        previewImg_width:{
          width:'100%',
        },
        previewModalBox: {
          position:'fixed',
          height:'100%',
          width:'100%',
          left:0,
          top:0,
          zIndex:9999999,
          display: 'none'
        },
        previewModal: {
          width:'100%',
          height:'100%',
          background:'#000',
          opacity:'0.7',
          zIndex:0,
          position:'absolute',
          left:0,
          top:0
        },
        previewImgBox: {
          width:'100%',
          height:'100%',
          zIndex:1,
          position:'absolute',
          left:0,
          top:0,
          display:'flex',
          alignItems: 'center',
          justifyContent: 'space-around'
        },
        closeBtn: {
          position:'absolute',
          fontSize: '30px',
          right: '20px',
          top:'20px',
          zIndex:2,
          color: '#fff',
          cursor: 'pointer'
        },
        downloadBtn: {
          position:'absolute',
          fontSize: '30px',
          right: '60px',
          top:'20px',
          zIndex:2,
          color: '#fff',
          cursor: 'pointer'
        },
        previewImg: {
          maxWidth: '500px'
        }
      }
    }
  },
  mounted(){
    this.addModal();
  },
  destroyed(){
    document.body.removeChild(this.modalDom)
  },
  methods: {
    openModal(){
      console.log(this.modalDom)
      this.modalDom&&(this.modalDom.style.display = 'block')
      let img =  this.modalDom.getElementsByTagName('img');
      if(img!=undefined&&img.length>0){
        if(img[0].width>img[0].height){
          this.addStyle(img[0],this.kstyles['previewImg_width'])
        }else{
          this.addStyle(img[0],this.kstyles['previewImg_heigth'])
        }
      }
    },
    closeModal(){
      this.modalDom&&(this.modalDom.style.display = 'none')
    },
    addModal(){
      this.modalDom = document.createElement('div')
      this.addStyle(this.modalDom,this.kstyles['previewModalBox'])
      let downloadBtn = document.createElement('i')
      downloadBtn.className = "ivu-icon ivu-icon-md-download"
      this.addStyle(downloadBtn,this.kstyles['downloadBtn'])
      let closeBtn = document.createElement('i')
      closeBtn.className = "ivu-icon ivu-icon-md-close"
      this.addStyle(closeBtn,this.kstyles['closeBtn'])
      let previewModal = document.createElement('div')
      this.addStyle(previewModal,this.kstyles['previewModal'])
      let previewImgBox = document.createElement('div')
      this.addStyle(previewImgBox,this.kstyles['previewImgBox'])
      let previewImg = document.createElement('img')
      previewImg.src = this.src
      this.addStyle(previewImg,this.kstyles['previewImg'])
      previewImgBox.appendChild(downloadBtn)
      previewImgBox.appendChild(closeBtn)
      previewImgBox.appendChild(previewImg)
      this.modalDom.appendChild(previewModal)
      this.modalDom.appendChild(previewImgBox)
      document.body.appendChild(this.modalDom)
      previewImgBox.onclick = (e) => {
        this.closeModal()
      }
      downloadBtn.onclick = (e)=>{
        e.stopPropagation()
        this.handleDownload()
      }
    },
    addStyle(dom,styles){
      for(let i in styles){
        dom.style[i] = styles[i]
      }
    },
    handleView(){
      this.openModal();
    },
    handleDownload(){
      var downloadA = document.createElement('a')
      downloadA.href = this.src
      document.body.appendChild(downloadA)
      downloadA.click()
      setTimeout(()=>{
        document.body.removeChild(downloadA)
      },1)
    }
  }
}
</script>

<style scoped lang = "less">
.img-preview-wrap{
  display:inline-block;
  position:relative;
}
.img-preview-wrap img{
  width:100%;
  height:100%;
  display:block;
}
.demo-upload-list-cover{
    width:100%;
    height:100%;
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
    align-items: center;
    justify-content: space-between;
    text-indent:0;
}
.demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    width:20px;
    height:20px;
    margin:0;
}
.img-preview-wrap:hover .demo-upload-list-cover{
    display: flex;
}
.com-preview-modal-box{
  position:fixed;
  height:100%;
  width:100%;
  z-index:9999999;
  left:0;
  top:0;
  .com-preview-modal{
    width:100%;
    height:100%;
    background:#000;
    opacity:0.7;
    z-index:0;
    position:absolute;
    left:0;
    top:0;
  }
  .com-preview-img-box{
    width:100%;
    height:100%;
    z-index:1;
    position:absolute;
    left:0;
    top:0;
    display:flex;
    align-items: center;
    justify-content: space-between;
    img{
      width:500px;
    }
  }
}
</style>